// The `gundi:jq_transform` ui_schema annotation a connector puts on an outbound
// jq_filter field: which sibling fields hold the data type and batch flag, the
// reference action that returns captured samples, and per data type the JSON schema
// of the jq input record and an example record shaped exactly like it.
export const JQ_TRANSFORM_KEY = 'gundi:jq_transform';

export type JqTransformAnnotation = {
  output_type_field?: string;
  batch_field?: string;
  samples_action?: string;
  schemas?: Record<string, any>;
  examples?: Record<string, any>;
};

export const outputTypeField = (a: JqTransformAnnotation) =>
  a.output_type_field || 'output_type';
export const batchField = (a: JqTransformAnnotation) =>
  a.batch_field || 'batch_mode';
export const samplesAction = (a: JqTransformAnnotation) =>
  a.samples_action || 'get_data_samples';

export function readAnnotation(uiSchema: any): JqTransformAnnotation | null {
  const annotation = uiSchema?.[JQ_TRANSFORM_KEY];
  return annotation &&
    typeof annotation === 'object' &&
    !Array.isArray(annotation)
    ? annotation
    : null;
}

export function exampleFor(a: JqTransformAnnotation, outputType: string): any {
  return a.examples?.[outputType];
}

/** The input schema for a data type; in batch mode, an array of it titled by `batchTitle`
 *  (definitions stay at the root so `$ref`s resolve). */
export function inputSchemaFor(
  a: JqTransformAnnotation,
  outputType: string,
  batch: boolean,
  batchTitle: (title: string) => string,
): any {
  const schema = a.schemas?.[outputType];
  if (!schema || !batch) return schema;
  const { definitions, $defs, ...item } = schema;
  return {
    title: batchTitle(schema.title ?? outputType),
    type: 'array',
    items: item,
    ...(definitions ? { definitions } : {}),
    ...($defs ? { $defs } : {}),
  };
}

export function outputTypeLabel(
  a: JqTransformAnnotation,
  outputType: string,
): string {
  const title = a.schemas?.[outputType]?.title;
  return typeof title === 'string' && title.trim() ? title : outputType;
}
